// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Модальное уведомление «страница в разработке» */
.dev-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(3px);
}

.dev-modal {
  width: min(440px, 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 28px 26px 22px;
  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));
  border-radius: 18px;
  background: var(--bg-primary, #fff);
  color: var(--text-primary, #0f172a);
  text-align: center;
  box-shadow: 0 28px 70px -24px rgba(0, 0, 0, 0.55);
}

.dev-modal-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(245, 158, 11, 0.16);
  color: var(--accent-warning, #d97706);
}

:root[data-theme='dark'] .dev-modal-icon {
  background: rgba(251, 191, 36, 0.14);
  color: #fbbf24;
}

.dev-modal-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.dev-modal-text {
  margin: 0;
  color: var(--text-secondary, #64748b);
  font-size: 0.92rem;
  line-height: 1.55;
}

.dev-modal-btn {
  width: 100%;
  margin-top: 6px;
  padding: 12px 18px;
  border: none;
  border-radius: 12px;
  background: var(--accent-primary, #2563eb);
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
}

.dev-modal-btn:hover {
  background: var(--accent-hover, #1d4ed8);
}
`, "",{"version":3,"sources":["webpack://./src/css/dev-notice.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gEAAgE;EAChE,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["/* Модальное уведомление «страница в разработке» */\n.dev-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 1400;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(3px);\n}\n\n.dev-modal {\n  width: min(440px, 100%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 28px 26px 22px;\n  border: 1px solid var(--border-color, rgba(148, 163, 184, 0.22));\n  border-radius: 18px;\n  background: var(--bg-primary, #fff);\n  color: var(--text-primary, #0f172a);\n  text-align: center;\n  box-shadow: 0 28px 70px -24px rgba(0, 0, 0, 0.55);\n}\n\n.dev-modal-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(245, 158, 11, 0.16);\n  color: var(--accent-warning, #d97706);\n}\n\n:root[data-theme='dark'] .dev-modal-icon {\n  background: rgba(251, 191, 36, 0.14);\n  color: #fbbf24;\n}\n\n.dev-modal-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.dev-modal-text {\n  margin: 0;\n  color: var(--text-secondary, #64748b);\n  font-size: 0.92rem;\n  line-height: 1.55;\n}\n\n.dev-modal-btn {\n  width: 100%;\n  margin-top: 6px;\n  padding: 12px 18px;\n  border: none;\n  border-radius: 12px;\n  background: var(--accent-primary, #2563eb);\n  color: #fff;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.dev-modal-btn:hover {\n  background: var(--accent-hover, #1d4ed8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
